import React, {useState}  from 'react';
import Nav from './Nav';
import Footer from './Footer';
import './home.css';
import './Sales.css';
import { Link,useNavigate } from 'react-router-dom';
import { MdKeyboardBackspace } from "react-icons/md";
import {postedSalesCreditmemo as PS} from '../HelperFx/datalinks';
import DataTable from 'react-data-table-component';
import { Buffer } from 'buffer';
import useFetch from '../Components/UseFetch';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {IconButton} from '@mui/material';
import {postedSalesCreditmemo} from '../HelperFx/datalinks';
import verifyToken from '../HelperFx/verifyJwt.js';

const REACT_UNAME = process.env.REACT_APP_API_USERNAME;

const REACT_PWD = process.env.REACT_APP_API_PASSWORD;

const REACT_DATA_URL = process.env.REACT_APP_API_DATA_URL;

const REACT_APP_COMPANY_URL = process.env.REACT_APP_COMPANY;


const eq = ' eq ';
const filter = '&$filter =';

const CustTable = () => {
  const token = Buffer.from(`${REACT_UNAME}:${REACT_PWD}`, 'utf8').toString('base64');
  const jwttoken = sessionStorage.getItem('authToken');
  const {custName, userName, userType,  password} = verifyToken(jwttoken);
  //Console.log(custName,userName, userType, password);

  // const customerLink = `${process.env.REACT_APP_API_URL}${customers}`; // Replace with the actual API URL
  const { data: salesCreditMemo, loading, error } = useFetch(`${REACT_DATA_URL}${postedSalesCreditmemo}?${REACT_APP_COMPANY_URL}&${filter}customerNo${eq}'${custName}'`, token);
  const creditMemoInformation = salesCreditMemo?.value

  //Console.log(creditMemoInformation);

  const navigate = useNavigate();

  const data = creditMemoInformation || [];

  const [searchTerm, setSearchTerm] = useState('');

  const columns = [
    { name: 'No.',
      selector: row =>
      (
        <span
          style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
          onClick={() => navigate(`/PurchaseCreditMemo`, {state: {number: row.number}})}>
          {row.number}
        </span> 
      ),
      sortable: true },
    { name: 'Customer Name', selector: row => row.customerName, sortable: true },
    { name: 'Customer Contact', selector: row => row.phoneNumber, sortable: true },
    { name: 'Amount', selector: row => row.lineAmount, sortable: true },
    { name: 'Due Date', selector: row => row.dueDate, sortable: true },
  ];

  const filteredData = data.filter(item => 
    item.number.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.customerName.toLowerCase().includes(searchTerm.toLowerCase())||
    item.lineAmount === parseFloat(searchTerm)
  );

  return (
    <div>
      <input
        type="text"
        placeholder="Search"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className='table-search'
      />

      <DataTable
        // title="Items List"
        columns={columns}
        data={filteredData}
        pagination
        customStyles={{
          rows: {
            style: {
              minHeight: '33px',
            },
          },
        }}
      />
    </div>
  );
};

const SalesCreditMemos = () => {
  return (
    <div className="Home">
      <Nav/>
      <div className="dash-main">
        <div className="squote">
          <div className="firsttab">
          {/* <Link to="/home"><MdKeyboardBackspace style={{ width: "50px"}}/></Link> */}
          <IconButton component={Link} to="/home">
              <ArrowBackIcon sx={{ fontSize: "1.5rem" }} />
            </IconButton>

            <span>Processed Purchase Credit Memos</span>
            {/* <div className="actions">
              <a class="btn btn-sm border-black rounded-pill px-4 mx-2 action-btn" role="button" >Print</a>
            </div> */}
          </div>

          <div className="listTable">
            <CustTable/>
          </div>
        </div>
      </div>
      <Footer/>
  </div>
  )
}

export default SalesCreditMemos;